import Vue, { VueConstructor } from 'vue'

import App from './App.vue'
import { getJsonData } from '@/common/utils/dom'
import { JSON_SELECTOR } from '@/common/constants'

import './main.entry.css'

const mountEl = document.getElementById('js-stock-library') as HTMLElement

const currentUser = getJsonData(JSON_SELECTOR.CURRENT_USER)

const urlParams = new URLSearchParams(window.location.search)
const isCrossSell = urlParams.get('href') === 'p1'

const install = (mountEl: HTMLElement, component: VueConstructor<Vue>) => {
  if (!mountEl) {
    return false
  }

  new Vue({
    render: h => h(component, {
      props: {
        isLoggedIn: !!currentUser,
        isCrossSell
      }
    })
  }).$mount(mountEl)
}

install(mountEl, App)
